import api from './index';
import { AxiosResponse } from 'axios';

// AB1文件解析结果类型
export interface AB1FileData {
  sequence: string;
  channels: {
    A: number[];
    C: number[];
    G: number[];
    T: number[];
  };
  peak_positions: number[];
  confidence_levels: string[];
  qualities: number[];  // 添加质量分数字段
}

export interface AB1FileResult {
  filename: string;
  data: AB1FileData;
}

// 序列组装相关类型
export interface FastaSequence {
  name: string;
  sequence: string;
}

export interface AssemblyPath {
  sequence_id: string;
  direction: string;
}

export interface Contig {
  id: string;
  sequence: string;
  length: number;
  assembly_path: AssemblyPath[];
}

export interface AssemblyResult {
  contigs: Contig[];
  timestamp: string;
}

/**
 * 上传并解析AB1文件
 * 
 * @param files - 要上传的AB1文件数组
 * @returns 解析结果
 */
export const parseAB1Files = async (files: File[]): Promise<AB1FileResult[]> => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await api.post<AB1FileResult[]>(
      '/clone/sanger_sequencing/ab1parse',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response;
  } catch (error) {
    console.error('解析AB1文件失败:', error);
    throw error;
  }
};

/**
 * 组装AB1序列
 * 
 * @param results - AB1解析结果列表
 * @param minOverlapLength - 最小重叠长度
 * @param minPhredScore - 最小质量分数
 * @returns 组装结果
 */
export const assembleAB1Sequences = async (
  results: AB1FileResult[],
  minOverlapLength: number = 15,
  minPhredScore: number = 10
): Promise<AssemblyResult> => {
  try {
    const response = await api.post<AssemblyResult>(
      '/clone/sanger_sequencing/assemble/ab1',
      {
        results,
        min_overlap_length: minOverlapLength,
        min_phred_score: minPhredScore
      }
    );

    return response;
  } catch (error) {
    console.error('组装AB1序列失败:', error);
    throw error;
  }
};

/**
 * 组装FASTA序列
 * 
 * @param sequences - FASTA序列列表
 * @param minOverlapLength - 最小重叠长度
 * @returns 组装结果
 */
export const assembleFastaSequences = async (
  sequences: FastaSequence[],
  minOverlapLength: number = 15
): Promise<AssemblyResult> => {
  try {
    const response = await api.post<AssemblyResult>(
      '/clone/sanger_sequencing/assemble/fasta',
      {
        sequences,
        min_overlap_length: minOverlapLength
      }
    );

    return response;
  } catch (error) {
    console.error('组装FASTA序列失败:', error);
    throw error;
  }
}; 